import api from './api';

const animalService = {
  // Get all animals
  getAllAnimals: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.breed) params.append('breed', filters.breed);
    if (filters.health_status) params.append('health_status', filters.health_status);
    if (filters.search) params.append('search', filters.search);
    
    const response = await api.get(`/api/animals?${params.toString()}`);
    return response.data;
  },

  // Get animal by ID
  getAnimalById: async (id) => {
    const response = await api.get(`/api/animals/${id}`);
    return response.data;
  },

  // Create animal
  createAnimal: async (animalData) => {
    const response = await api.post('/api/animals', animalData);
    return response.data;
  },
  // Get next tag number for animal type
getNextTagNumber: async (type) => {
  const response = await api.get(`/api/animals/next-tag?type=${type}`);
  return response.data;
},

  // Update animal
  updateAnimal: async (id, animalData) => {
    const response = await api.put(`/api/animals/${id}`, animalData);
    return response.data;
  },

  // Delete animal
  deleteAnimal: async (id) => {
    const response = await api.delete(`/api/animals/${id}`);
    return response.data;
  },

  // Get statistics
  getStats: async () => {
    const response = await api.get('/api/animals/stats');
    return response.data;
  },
  // Get milking female animals (for production entry)
  getMilkingAnimals: async () => {
    const response = await api.get('/api/animals/milking');
    return response.data;
  },
};

export default animalService;